export class RegistrationPersonal {

  birthAt: string;
  genre: string;
  nationality: string;
  birthPlace: string;

  constructor() {
    this.birthAt = null;
    this.genre = null;
    this.nationality = null;
    this.birthPlace = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/registrationpersonal.ts